module.exports = __webpack_public_path__ + "static/img/26832.ecdf1f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/productCenter/zgds/26832.png
// module id = Tl+D
// module chunks = 0